<template>
	<b-row class="mt-3 bg-gray-light">
		<b-col xl="7">
			<div class="text-center w-100 is-align-middle">
				<b-icon
					icon="three-dots"
					class="text-center"
					animation="cylon"
					font-scale="4"
					v-if="loadingStatus"
				></b-icon>
			</div>
			<div id="view-map-display" class="map-canvas" v-if="!loadingStatus && !noData" style="height: 450px"></div>
			<div v-if="noData" class="text-center">
				<img src="../../assets/img/lost_in_space.jpg" alt="Unable to locate subscriber" style="width: 100%" />
				<br />
				<span class="h3 text-danger">{{ errorText }}</span>
			</div>
		</b-col>
		<b-col xl="5">
			<b-table class="view-map-custom" hover :items="items" :fields="fields"></b-table>
		</b-col>
	</b-row>
</template>

<script>
// //https://www.npmjs.com/package/google-maps
// import {Loader} from 'google-maps';
// // Initializing with API key
// const loader = new Loader( configDirective.getGoogleApiKey() );

export default {
	name: "View-Map",

	data() {
		return {
			loadingStatus: true,
			noData: false,
			errorText: "",
			mapData: [],
			fields: [],
			items: [],
		};
	},

	async mounted() {
		// Initializing with API key
		// const loader = new Loader(configDirective.getGoogleApiKey());
		// const google = await loader.load();
		this.$root.$on("viewMap", event => {
			if (Array.isArray(event)) {
				setTimeout(() => {
					this.initMap(google, event);
				}, 2200);
				this.loadingStatus = false;
			} else {
				this.errorText = "Unable to locate subscriber";
				if (process.env.NODE_ENV === "dev") console.error("MAP ERROR:", event);
				this.noData = true;
				this.loadingStatus = false;
			}
		});
	},
	methods: {
		async initMap(google, res) {
			//if (window?.google) return window.google;
			try {
				//let map;
				let event = res[0];
				let icon_cgreen = "https://i.imgur.com/CM5c7BE.png";
				//console.log('[Provisioning-View-Map.vue] mapDiv: view-map-display');
				//map = document.getElementById('view-map-display');
				let center = new google.maps.LatLng(event.lat, event.lon);
				let zoom = 15;
				let el = null;
				try {
					el = document.getElementById("view-map-display");
					if (typeof el === "undefined") return;
				} catch (e) {
					//console.error(e);
					return;
				}
				console.log("map el1", el);

				const map = new google.maps.Map(el);
				map.setCenter(center);
				map.setZoom(zoom);
				map.setMapTypeId(google.maps.MapTypeId.ROADMAP);

				res.forEach(item => {
					if (process.env.NODE_ENV === "dev") console.log("adding new marker...", item);
					let latlng = new google.maps.LatLng(item.lat, item.lon);
					let marker = new google.maps.Marker({
						position: latlng,
						map: map,
						animation: google.maps.Animation.DROP,
						title: "Map Marker",
						icon: icon_cgreen,
					});
					let contentString =
						'<div class="info-window-content"><h3 class="mt-3">Authorization Date: <span class="text-sm">' +
						item.authdate +
						"</span></h3>" +
						'<h3>Connection Type: <span class="text-sm">' +
						item.connectiontype +
						"</span></h3></div>";
					let infowindow = new google.maps.InfoWindow({
						content: contentString,
					});
					google.maps.event.addListener(marker, "click", function () {
						infowindow.open(map, marker);
					});
				});

				//add the array to the table.
				this.items = [
					{key: "IMSI", value: event.imsi},
					{key: "Mcc", value: event.mcc},
					{key: "Mnc", value: event.mnc},
					{key: "Cell", value: event.cid},
					{key: "Area", value: event.lac},
					{key: "Latitude", value: event.lat},
					{key: "Longitude", value: event.lon},
					{key: "Last Session", value: event.authdate},
					{key: "No of Sessions", value: event.sessions},
				];
			} catch (e) {
				console.error(e);
			}
		},
	},
};
</script>
